<!--called from COE-->
<span *ngIf="node">
	<span *ngIf="!node.NODE_HISTORIES || (node.NODE_HISTORIES && node.NODE_HISTORIES.length <= 0)">
		{{node.WORKFLOW_STATE_TYPES.DESCRIPTION}}
	</span>
	<span *ngIf="node.NODE_HISTORIES && node.NODE_HISTORIES.length > 0">
		{{node.NODE_HISTORIES[node.NODE_HISTORIES.length - 1].WORKFLOW_STATE_TYPES1.DESCRIPTION}}
	</span>
	<span [class]="output.class">
		<span *ngIf="!output.sameState">
			{{output.result}}
		</span>
	</span>
</span>
<!--called from Workbench-->
<span *ngIf="!node">
	<span *ngIf="nodeHistory && nodeHistory.length > 0">
		{{nodeHistory[nodeHistory.length - 1].WORKFLOW_STATE_TYPES1.DESCRIPTION}}
	</span>
	<span [class]="output.class">
		<span *ngIf="!output.sameState">
			{{output.result}}
		</span>
	</span>
</span>